import { actionTypes } from '../types/actionTypes'
import {
  GenericInputType,
  PositionInput,
  ReducerRelocateState
} from '../types/reducerTypes'

const initialInputValues: GenericInputType = {
  error: '',
  value: '',
  status: 'default'
}

const initialPositionValues: PositionInput = {
  positionId: 0,
  positionName: '',
  positionCode: '',
  positionDescription: '',
  typePositionId: 0,
  zone: {
    zoneCode: '',
    zoneId: 0,
    zoneName: ''
  }
}

/*
Copyright 2022-04-07 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se agregan reducer para sku y ubicación

Copyright 2022-04-08 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se agregan reducer para listado de skus

Copyright 2022-04-12 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se agrega reducer para exceso (calculo y estado)
*/

export const initialState: ReducerRelocateState = {
  isSelected: 'WorkOrderId',
  searchValue: '',
  positionId: 0,
  workOrderInboundLocate: [],
  error: '',
  step: 1,
  loading: false,
  item: undefined,
  endUbication: initialInputValues,
  startUbication: initialInputValues,
  skuEan: initialInputValues,
  inputQty: initialInputValues,
  isSelectedFieldView: 'skuId',
  SkuListOnPosition: [],
  isShowNotification: false,
  isShowExcess: false,
  isExcess: false,
  calculatedExcess: 0,
  userId: 0,
  calculatedInbound: 0,
  skuLocated: '',
  isFlipped: false,
  workOrderSkuHistory: [],
  loadingHistory: false,
  stepInput: 0,
  originPosition: { ...initialPositionValues },
  destinyPosition: { ...initialPositionValues },
  positionsList: [],
  documentNumber: initialInputValues,
  observation: initialInputValues,
  productOriginId: initialInputValues,
  stockKeepingUnits: []
}

// Creación del reducer el cual recibira como parametro nuestro estado y nuestras acciones
export const relocateReducer = (
  state: ReducerRelocateState,
  action: actionTypes
) => {
  switch (action.type) {
    case 'setSearch':
      return {
        ...state,
        isSelected: action.payload
      }
    case 'setSearchValue':
      return {
        ...state,
        searchValue: action.payload
      }
    case 'setWorkOrderLocate':
      return {
        ...state,
        workOrderInboundLocate: action.payload
      }
    case 'setItem':
      return {
        ...state,
        item: action.payload
      }
    case 'setError':
      return {
        ...state,
        error: action.payload
      }
    case 'setStep':
      return {
        ...state,
        step: action.payload
      }
    case 'setLoading':
      return {
        ...state,
        loading: action.payload
      }
    case 'setInputQty':
      return {
        ...state,
        inputQty: action.payload
      }
    case 'setStartUbication':
      return {
        ...state,
        startUbication: action.payload
      }
    case 'setEndUbication':
      return {
        ...state,
        endUbication: action.payload
      }
    case 'setSkuEan':
      return {
        ...state,
        skuEan: action.payload
      }
    case 'setResetState':
      return initialState

    case 'setViewField':
      return {
        ...state,
        isSelectedFieldView: action.payload
      }
    case 'setItemList':
      return {
        ...state,
        SkuListOnPosition: action.payload
      }
    case 'setResetPageState':
      return {
        ...state,
        inputQty: initialInputValues,
        skuEan: initialInputValues,
        ubication: initialInputValues,
        SkuListOnPosition: []
      }

    case 'setIsShowNotification': {
      return {
        ...state,
        isShowNotification: action.payload
      }
    }
    case 'setPositionId':
      return {
        ...state,
        positionId: action.payload
      }
    case 'setResetLocate':
      return {
        ...state,
        inputQty: initialInputValues,
        skuEan: initialInputValues
      }
    case 'setIsExcess':
      return {
        ...state,
        isExcess: action.payload
      }
    case 'setCalculatedExcess': {
      return {
        ...state,
        calculatedExcess: action.payload,
        isExcess: action.payload > 0
      }
    }

    case 'setUserId':
      return {
        ...state,
        userId: action.payload
      }

    case 'setIsShowExcess': {
      return {
        ...state,
        isShowExcess: action.payload
      }
    }
    case 'setCalculatedInbound':
      return {
        ...state,
        calculatedInbound: action.payload
      }

    case 'setSkuLocated':
      return {
        ...state,
        skuLocated: action.payload
      }
    case 'setIsFlipped':
      return {
        ...state,
        isFlipped: action.payload
      }

    case 'setWorkOrderSkuHistory':
      return {
        ...state,
        workOrderSkuHistory: action.payload
      }
    case 'setLoadingHistory':
      return {
        ...state,
        loadingHistory: action.payload
      }
    case 'setStepInput':
      return {
        ...state,
        stepInput: action.payload
      }
    case 'setOriginPosition':
      return {
        ...state,
        originPosition: action.payload
      }
    case 'setDestinyPosition':
      return {
        ...state,
        destinyPosition: action.payload
      }
    case 'setPositionsList':
      return {
        ...state,
        positionsList: action.payload
      }
    case 'setDocumentNumber':
      return {
        ...state,
        documentNumber: action.payload
      }

    case 'setObservation':
      return {
        ...state,
        observation: action.payload
      }

    case 'setProductOriginId':
      return {
        ...state,
        productOriginId: action.payload
      }

    case 'setFoundedProducts':
      return {
        ...state,
        stockKeepingUnits: action.payload
      }

    default:
      return state
  }
}
